import SidebarDetailsContainer from "../../../Components/Blog/SidebarDetails";

const SidebarDetails = () => {
  return <SidebarDetailsContainer />;
};

export default SidebarDetails;
